class ProductBundleOptions extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.productFormId;
    this.form = document.getElementById(this.formId);

    if (!this.form) return;

    this.radios = this.querySelectorAll('[data-bundle-radio]');
    this.items = this.querySelectorAll('[data-bundle-option]');
    this.hiddenState = this.querySelector('[data-bundle-selected-quantity]');

    this.ensureQuantityInput();
    this.bindEvents();
    this.syncSelectedQuantity();
  }

  ensureQuantityInput() {
    this.quantityInput = this.form.querySelector('input[name="quantity"]');

    if (!this.quantityInput) {
      this.quantityInput = document.createElement('input');
      this.quantityInput.type = 'hidden';
      this.quantityInput.name = 'quantity';
      this.quantityInput.value = '1';
      this.form.appendChild(this.quantityInput);
    }
  }

  bindEvents() {
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.updateActiveState();
        this.syncSelectedQuantity();
      });
    });
  }

  updateActiveState() {
    this.items.forEach((item) => item.classList.remove('is-active'));

    const checkedRadio = this.querySelector('[data-bundle-radio]:checked');
    if (!checkedRadio) return;

    const currentItem = checkedRadio.closest('[data-bundle-option]');
    if (currentItem) currentItem.classList.add('is-active');
  }

  syncSelectedQuantity() {
    const checkedRadio = this.querySelector('[data-bundle-radio]:checked');
    if (!checkedRadio || !this.quantityInput) return;

    const qty = checkedRadio.value || '1';
    this.quantityInput.value = qty;

    if (this.hiddenState) {
      this.hiddenState.value = qty;
    }
  }
}

customElements.define('product-bundle-options', ProductBundleOptions);